/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { removeSideBar } from 'features/components/base/auth-pages/MyAccount/MyAccountMenuList';
import PaginationBox from 'features/components/base/public/HOC/PaginationBox';
import store from 'features/store';
import { Component, createRef } from 'react';
import { OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import { deleteIcon, editIcon, downSideArrow,rightSideArrow } from 'shared/assets/icons';
// project imports
import { getBuyersUrl, getBuyerHeaders, getPaymentHeaders, getPaymentUrl } from 'shared/http';
import { CommonService } from 'shared/services';
import { logout } from 'shared/settings/auth';

// style imports
import './Datatable.scss';
import { Pagination } from 'features/components/base/public/HOC/Pagination';

/**
 * generic table to render provided data in tabular format
 * 
 * @param config
 * 
 * @returns html code to rener table on specified api data
 * 
**/

export class Datatable extends Component {

    allRows;
    field;
    actionRefs;

    constructor(props) {
        super(props);
        this.state = {
            // user defined properties
            pagination: props.config.pagination,
            sort: props.config.sort,
            search: props.search,
            accordion: {
                display: props.config.columns[props.config.columns.length - 1]['actions']?.includes('accordion'),
                rowId: -1
            },
            extraButton: props.config.extraButton ? props.config.extraButton : null,

            // contains data for each row
            rows: [],

            // table pagination details
            size: 10,
            totalRows: null,
            page: 1,
            maxPage: 1,
            next: null,
            previous: null,
            paginationState: {},
            from: null,
            to: null,

            // loading
            tableLoading: false,
            allItemsSelected: false,
            pageData: {}
        };

        if (this.props?.location && this.props?.location?.state && this.props?.location?.state?.datatable) {
            let temp = {};
            if (this.props.location.state?.datatable?.datatable?.next) {
                temp['next'] = this.props?.location.state.datatable.datatable.next;
            } else if (this.props.location?.state?.datatable?.datatable?.previous) {
                temp['previous'] = this.props.location.state.datatable.datatable.previous;
            }

            if (this.props.location.state.datatable.datatable.sort) {
                temp['sort'] = this.props.location.state.datatable.datatable.sort;
            }

            if (this.props.location.state.datatable.datatable.search) {
                temp['search'] = this.props.location.state.datatable.datatable.search;
            }

            temp['page'] = this.props.location.state.datatable.datatable.page ? this.props.location.state.datatable.datatable.page : 1;
            temp['totalRows'] = this.props.location.state.datatable.datatable.totalRows ? this.props.location.state.datatable.datatable.totalRows : null;
            temp['maxPage'] = this.props.location.state.datatable.datatable.maxPage ? this.props.location.state.datatable.datatable.maxPage : 1;

            if (this.props.location.state.datatable.datatable.from) {
                temp['from'] = this.props.location.state.datatable.datatable.from;
            }

            if (this.props.location.state.datatable.datatable.to) {
                temp['to'] = this.props.location.state.datatable.datatable.to;
            }
           
            this.state = {
                ...this.state,
                ...temp
            };
        }


        this.allRows = [];
        this.field = props.config.field ? props.config.field : [];
        this.actionRefs = {
            clone: createRef(),
            notes: createRef(),
            dashboard: createRef(),
            view: createRef(),
            edit: createRef()
        };
    }

    componentDidMount() {
        this.state.search && this.state.search.searchData ? this.searchData(this.state.next ? 1 : this.state.previous ? -1 : null) : this.getTableData(this.state.next ? 1 : this.state.previous ? -1 : null);
    }

    // componentDidUpdate(prevProps, prevState) {
    //     let filterSearch = [];
    //     if (prevProps.search !== this.props.search) {
    //         if (this.props.search && this.props.search.searchData) {
    //             for (let key of Object.keys(this.props.search.search)) {

    //             }
    //         }
    //         this.setState({
    //             ...this.state,
    //             search: filterSearch,
    //             page: 1,
    //             next: null,
    //             previous: null,
    //             sort: this.props.config.sort
    //         }, () => this.getTableData());
    //     }
    // }
    selectAllCheckBox = () => {
        return (
            <><div><Form><Form.Check className="custom-header-checkbox" type="checkbox" onChange={(event) => { this.allItemsSelect(event) }} checked={this.state.allItemsSelected} /></Form></div></>
        );
    }
    allItemsSelect = (event) => {
        this.props.allItemsSelect(event);
    }
    checkBoxHandle = (value) => {
        this.setState({
            allItemsSelected: value
        });
    }
    searchData = (newPage = null) => {
        let filterSearch = [];
        const search = this.props.search ? this.props.search.search : {};

        Object.keys(search).forEach(key => {
            if (this.props.search.search[key].value) {
                filterSearch.push(this.props.search.search[key]);
            }
        });
        if (!newPage) {
            this.setState({
                search: filterSearch,
                page: 1,
                next: null,
                previous: null,
                sort: this.state.sort,
            }, () => this.getTableData(newPage));
        } else {
            this.setState({
                search: filterSearch,
                page: this.state.page,
                next: this.state.next,
                previous: this.state.previous,
                sort: this.state.sort,
            }, () => this.getTableData(newPage));
        }
    }

    getTableState = () => {
        const datatable = {};

        // check next or previous available
        if (Object.keys(this.state.paginationState).length) {
            if (this.state.paginationState.next) {
                datatable['next'] = this.state.paginationState.next;
            } else if (this.state.paginationState.previous) {
                datatable['previous'] = this.state.paginationState.previous;
            }
        }
        if (this.state.paginationState.search) {
            datatable['search'] = this.state.paginationState.search;
        }

        datatable['sort'] = this.state.paginationState.sort;
        datatable['page'] = this.state.paginationState.page;
        datatable['totalRows'] = this.state.paginationState.totalRows;
        datatable['maxPage'] = this.state.paginationState.maxPage;
        datatable['from'] = this.state.paginationState.from;
        datatable['to'] = this.state.paginationState.to;

        return datatable;
    };


    rowAction = (value, action, event) => {
        event.preventDefault();
        event.stopPropagation();
        action(value);
    };

    toggleAccordion = (index, event = null) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.setState({
            accordion: {
                display: true,
                rowId: this.state.accordion.rowId === index ? -1 : index
            }
        });
    };

    columnType = (row, column, index) => {
        if (row) {
            switch (column['columnType']) {
                case 'actions':
                    return (
                        <div className="d-flex flex-row align-items-center justify-content-between">

                            {/* action buttons on left side */}
                            <div className="d-flex flex-row action-button-group align-items-center">
                                {
                                    column['actions'].includes('clone') ?
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-clone">Clone</Tooltip>}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/clone.svg`} alt="clone" className="action-button" onClick={(event) => this.rowAction(row, column['actionEvents']['clone'], event)} />
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('notes') ?
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-notes">Notes</Tooltip>}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/notes.svg`} alt="notes" className="action-button" onClick={(event) => this.rowAction(row[column['property']], column['actionEvents']['notes'], event)} />
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('dashboard') ?
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-dashboard">Dashboard</Tooltip>}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/dashboard.svg`} alt="dashboard" className="action-button" onClick={(event) => this.rowAction(row[column['property']], column['actionEvents']['dashboard'], event)} />
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('view') ?
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-view">View</Tooltip>}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/view.svg`} alt="view" className="action-button" onClick={(event) => this.rowAction(row[column['property']], column['actionEvents']['view'], event)} />
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('edit') ?
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-edit">Edit</Tooltip>}>
                                            <div className="me-3" onClick={(event) => this.rowAction(row, column['actionEvents']['edit'], event)} >
                                                {editIcon}
                                            </div>
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('delete') ?
                                        <OverlayTrigger overlay={<Tooltip id="tooltip-edit">Delete</Tooltip>}>
                                            <div onClick={(event) => this.rowAction(row, column['actionEvents']['delete'], event)}>
                                                {deleteIcon}
                                            </div>

                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('accordion') ?
                                        (
                                            this.state.accordion.rowId === index ?
                                                <span style={{ cursor: 'pointer', marginLeft: '8px'}} onClick={() => this.setState({ accordion: { display: true, rowId: -1 } })}>{downSideArrow}</span> :
                                                <span  style={{ cursor: 'pointer' }} onClick={() => this.toggleAccordion(index)}>{rightSideArrow}</span>
                                        ) :
                                        null
                                }
                            </div>
                        </div>
                    );
                case 'custom':
                    return column['customColumn'](row);
                default:
                    return row[column['property']] ? row[column['property']] : '- - -';
            }
        }
    };

    setRequestData = (newPage, jumpPage) => {
        const data = {
            sort: this.state.sort
        };

        /* get only the specified fields */
        if (this.field.length) {
            data['field'] = this.field;
        }

        /* append if search is made */
        if (this.state.search) {
            data['filter'] = this.state.search;
        }

        data['page'] = {
            size: this.state.size
        };
        
        /* set page size if not set all data will be fetched */
        if (this.state.pagination) {
            data['page'] = {
                size: this.state.size
            };

            if ( jumpPage ) {
                data['page'] = jumpPage;
            } else if (newPage === 1) {
                data['page']['next'] = this.state.next;
            } else if (newPage === -1) {
                data['page']['previous'] = this.state.previous;
            }

            if ( this.state.from ) {
                data['page']['from'] = this.state.from;
            }

            if ( this.state.to ) {
                data['page']['to'] = this.state.to;
            }

            if ( this.state.from && this.state.to && this.state.totalRows ) {
                data['page']['total'] = this.state.totalRows;
            }
        }

        return data;
    };

    getTableData = (newPage = null, jumpPage = null,currentIndex =this.state.page) => {
        this.setState({  page:currentIndex,})
        const data = this.setRequestData(newPage, jumpPage);

        if (this.props.config.url) {
            this.setState({ tableLoading: true });
            const getList = this.props.config.service === 'BUYER' ?
                CommonService.commonPost(getBuyersUrl(this.props.config.url, this.props.config.params), JSON.stringify(data), getBuyerHeaders())
                :
                CommonService.commonPost(getPaymentUrl(this.props.config.url, this.props.config.params), JSON.stringify(data), getPaymentHeaders());

                // get table data based on service
                getList.then((response) => {
                    this.allRows = response.data['data'];
                    const emitData = JSON.parse(JSON.stringify(response.data));
                    if (response.data.hasOwnProperty('page')) {
                        this.setState({
                            rows: response.data['data'],
                            pageData: response.data['page'],
                            pagination: true,
                            next: response.data['page'].hasOwnProperty('keyset') && response.data['page']['keyset'].hasOwnProperty('next') ? response.data['page']['keyset']['next'] : '',
                            previous: response.data['page'].hasOwnProperty('keyset') && response.data['page']['keyset'].hasOwnProperty('previous') ? response.data['page']['keyset']['previous'] : '',
                            tableLoading: false,
                            paginationState: { 
                                page: currentIndex, 
                                totalRows: this.state.totalRows, 
                                maxPage: this.state.maxPage, 
                                sort: this.state.sort, 
                                search: this.state.search, 
                                size: this.state.size,
                                from: data.page.from,
                                to: data.page.to
                            },
                        },()=>{
                            if (data['page']) {
                                if (data['page']['next']) {
                                    this.setState({
                                        paginationState: {
                                            ...this.state.paginationState,
                                            next: data['page']['next']
                                        }
                                    });
                                } else if (data['page']['previous']) {
                                    this.setState({
                                        paginationState: {
                                            ...this.state.paginationState,
                                            previous: data['page']['previous']
                                        }
                                    });
                                }
                            }
                        });
                    } else {
                        this.setState({
                            rows: this.allRows.slice(0, 10),
                            pageData: {},
                            pagination: false,
                            next: '',
                            previous: '',
                            tableLoading: false,
                            paginationState: { page: this.state.page, 
                                totalRows: this.state.totalRows, 
                                maxPage: this.state.maxPage, 
                                sort: this.state.sort, 
                                search: this.state.search, 
                                size: this.state.PageSize > 0 ? this.state.PageSize : 10,
                                from: data.page.from,
                                to: data.page.to
                            }
                        });
                    }

                    if (this.state.page === 1) {
                        let totalRows;

                        /* checks whether to set total no. of rows */
                        if (response.data.hasOwnProperty('page')) {
                            if (response.data['page'].hasOwnProperty('total')) {
                                totalRows = response.data['page']['total'];
                            }
                        } else {
                            totalRows = response.data['data'].length
                        }

                        /* total can be zero so checking its undefined or not */
                        if (totalRows !== undefined) {
                            this.setState({
                                totalRows: totalRows,
                            }, () => {
                                this.setState({
                                    maxPage: Math.ceil(this.state.totalRows / this.state.size),
                                });
                            });
                        }
                        emitData['Total'] = totalRows;
                    }
                    emitData['datatable'] =  this.getTableState();
                    this.setState({
                        page: emitData["datatable"]?.["page"] || 1
                    })
                    this.props.onDataUpdate(emitData);
                })
                .catch(error => {
                    // TODO: Error message handle
                    if (error?.status === 401) {
                        store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                        logout(this.props.history, false);
                        removeSideBar();
                    } else {
                        this.setState({ tableLoading: false });
                    }
                });
        }
    };

    // setPage(offset) {
    //     this.setState({ accordion: { display: this.state.accordion.display, rowId: -1 } })
    //     if (!this.state.tableLoading) {
    //         if (offset === -1) {
    //             if (this.state.page !== 1) {
    //                 this.setState({
    //                     page: this.state.page - 1
    //                 }, () => {
    //                     this.setData(offset);
    //                 });
    //             }
    //         } else {
    //             if (this.state.page + 1 <= this.state.maxPage) {
    //                 this.setState({
    //                     page: this.state.page + 1
    //                 }, () => {
    //                     this.setData(offset);
    //                 });
    //             }
    //         }
    //     }
    // };


    // setPage(offset) {
    //     if (!this.state.tableLoading) {
    //         if (offset === -1) {
    //             if (this.state.page !== 1) {
    //                 this.setState({
    //                     page: this.state.page - 1
    //                 }, () => {
    //                     this.setData(offset);
    //                 });
    //             }
    //         } else {
    //             if (this.state.page + 1 <= this.state.maxPage) {
    //                 this.setState({
    //                     page: this.state.page + 1
    //                 }, () => {
    //                     this.setData(offset);
    //                 });
    //             }
    //         }
    //     }
    // };

    setData = (offset) => {
        if (this.state.pagination) {
            this.getTableData(offset);
        } else {
            this.setState({
                rows: this.allRows.slice((this.state.page - 1) * this.state.size, this.state.page * this.state.size)
            });
        }
    };

    sort = (field) => {
        const sort = this.state.sort.find(element => element['field'] === field);

        if (!sort) {
            return 'fa-exchange-alt unsort-90 text-white';
        } else if (sort['direction'] === 'asc') {
            return 'fa-long-arrow-alt-up text-secondary';
        } else {
            return 'fa-long-arrow-alt-down text-secondary';
        }
    };

    updateSort = (column) => {
        if (column['name']) {
            let direction = '';
            if (this.state.sort[0]['field'] === column['property'] && this.state.sort[0]['direction'] === 'asc') {
                direction = 'desc';
            } else {
                direction = 'asc';
            }

            this.setState({
                sort: [{ field: column['property'], direction: direction }],
                page: 1,
                next: null,
                previous: null
            });

            setTimeout(() => {
                if (this.state.pagination) {
                    this.getTableData();
                } else {
                    let sortData = [...this.allRows];

                    if (column['sortType']) {
                        sortData = this.sortType(column, [...sortData]);
                    } else {
                        this.state.sort.forEach(element => {
                            if (element['direction'] === 'asc') {
                                sortData.sort((a, b) => a[element['field']].toLowerCase() < b[element['field']].toLowerCase() ? -1 :
                                    a[element['field']].toLowerCase() > b[element['field']].toLowerCase() ? 1 : 0);
                            } else {
                                sortData.sort((a, b) => a[element['field']].toLowerCase() < b[element['field']].toLowerCase() ? 1 :
                                    a[element['field']].toLowerCase() > b[element['field']].toLowerCase() ? -1 : 0);
                            }
                        });
                    }

                    this.setState({ rows: sortData });
                }
            });
        }
    };

    sortType = (column, rowData) => {
        if (column['sortType'] === 'custom') {
            rowData = column['customSort']([...rowData]);
        } else if (column['sortType'] === 'num') {
            this.state.sort.forEach(element => {
                if (element['direction'] === 'asc') {
                    rowData.sort((a, b) => a[element['field']] < b[element['field']] ? -1 :
                        a[element['field']] > b[element['field']] ? 1 : 0);
                } else {
                    rowData.sort((a, b) => a[element['field']] < b[element['field']] ? 1 :
                        a[element['field']] > b[element['field']] ? -1 : 0);
                }
            });
        } else if (column['sortType'] === 'num-rev') {
            this.state.sort.forEach(element => {
                if (element['direction'] === 'desc') {
                    rowData.sort((a, b) => a[element['field']] < b[element['field']] ? -1 :
                        a[element['field']] > b[element['field']] ? 1 : 0);
                } else {
                    rowData.sort((a, b) => a[element['field']] < b[element['field']] ? 1 :
                        a[element['field']] > b[element['field']] ? -1 : 0);
                }
            });
        }

        return rowData;
    };

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }
    render() {
        return (
            <div style={{ width: "100%" }}>
                <div className="border border-outline" style={{ overflowX: 'auto', position: 'relative', width: "100%" }}>
                    <table className="table-box">
                        <thead className="table-head">
                            <tr className="row-height">
                                {
                                    this.props.config.columns.map((column, colIdx) =>
                                        // ${column['columnType'] === 'actions' ? 'action-cell' : ''}
                                        <th scope="col" key={colIdx} className={`px-2 ${column['sort'] ? 'header-cell' : ''}`}
                                            style={{ minWidth: column['width'], width: column['width'], color: 'white', fontWeight: 'normal' }}
                                            onClick={() => column['sort'] ? this.updateSort(column) : null}>
                                            {column['customHeader'] ? column['customHeader'] === 'selectAll' ? this.selectAllCheckBox() : column['customHeader'] : column['name']}
                                            {
                                                column['sort'] ?
                                                    <i className={`fa ${this.sort(column['property'])}`} style={{ margin: '0 4px' }}></i> :
                                                    null
                                            }
                                        </th>
                                    )
                                }
                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {
                                this.state.rows.length ?
                                    [...Array(this.state.rows.length < 10 ? this.state.rows.length : this.state.size).keys()].map((index) =>
                                        [
                                            <tr key={index} className={`row-height row-border ${this.state.accordion.display && this.state.rows[index] ? 'row-border clickable' : ''}`}
                                                onClick={this.state.accordion.display && this.state.rows[index] ? (event) => this.toggleAccordion(index, event) : null}>
                                                {
                                                    this.props.config.columns.map((column, colIdx) =>
                                                        // className={`${column['columnType'] === 'actions' ? 'action-cell' : ''}`}
                                                        <td scope="row" key={colIdx} style={{ padding: '0 0.5rem' }}>
                                                            {this.columnType(this.state.rows[index], column, index)}
                                                        </td>
                                                    )
                                                }
                                            </tr>,
                                            this.state.accordion.display && this.state.accordion.rowId === index ?
                                                <tr key={`1${index}`} className="row-bg-accordion row-border">
                                                    <td colSpan={this.props.config.columns.length}>
                                                        {this.props.config.columns[this.props.config.columns.length - 1]['accordion'](this.state.rows[index])}
                                                    </td>
                                                </tr> :
                                                null
                                        ]
                                    ) :
                                    <tr style={{ height: '500px' }}>
                                        {(this.props.config.url == "/api/v1/buyer/vault/card/list" && this.props.config.columns.length) ? 
                                            <td colSpan={this.props.config.columns.length}>
                                                <div className="d-flex align-items-center justify-content-center" style={{ width: '100%', height: '100%' }}>{this.state.tableLoading ? '' : 'Please select Add Payment Method and follow the steps to complete your profile.'}</div>
                                            </td> : 
                                            <td colSpan={this.props.config.columns.length}>
                                                <div className="d-flex align-items-center justify-content-center" style={{ width: '100%', height: '100%' }}>{this.state.tableLoading ? '' : 'No data available'}</div>
                                            </td>
                                        }
                                    </tr>
                            }
                        </tbody>
                    </table>
                    {
                        this.state.tableLoading ?
                            <div className="d-flex align-items-center justify-content-center page-loader">
                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                            </div> :
                            null
                    }
                </div>
                {
                    this.state.rows.length ?
                        <div className="d-flex flex-column flex-sm-row align-items-center justify-content-sm-between" style={{ width: '100%' }}>
                            <span>Showing <b>{this.state.totalRows > this.state.page * this.state.size ? this.state.page * this.state.size : this.state.totalRows}</b> of <b>{this.state.totalRows}</b> records</span>
                            <div className="custom-align-middle">
                                {this.state.extraButton ?
                                    this.state.extraButton()
                                    : null
                                }
                                {/* <div className="m-3 m-sm-0" style={{ cursor: 'default', border: '1px solid #0000004a' }}>
                                    <i className={`fa fa-angle-double-left page-switch ${!this.state.tableLoading && this.state.page !== 1 ? 'switch-enable' : 'switch-disable'}`} onClick={() => this.setPage(-1)} />
                                    <span style={{ borderLeft: '1px solid #0000004a', borderRight: '1px solid #0000004a', padding: '4px 12px' }}>Page {this.state.page}</span>
                                    <i className={`fa fa-angle-double-right page-switch ${!this.state.tableLoading && this.state.page !== this.state.maxPage ? 'switch-enable' : 'switch-disable'}`} onClick={() => this.setPage(1)} />
                                </div> */}
                                <Pagination loading={this.state.tableLoading} page={{...this.state.pageData,total:this.state.totalRows ||this.state.pageData?.total}} 
                                onPageChangeCallback={(page, currentPageNumber) => { 
                                    this.setState({
                                        from: page.from || null,
                                        to: page.to || null
                                    }, () => {
                                        this.getTableData(null, page, currentPageNumber);
                                    })
                                }} 
                                pageData={{
                                    currentindex:this.state.page,
                                    total:this.state.totalRows 
                                }}/>
                            </div>
                        </div> :
                        null
                }
            </div>
        );
    }
}